import { useNavigate } from 'react-router'
import React from 'react'
import Business from '@mui/icons-material/Business'
import CalendarMonth from '@mui/icons-material/CalendarMonth'
import Description from '@mui/icons-material/Description'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import {
  SupportHomePageContainer,
  SupportHomePageItem,
  TILE_COLORS,
  TileIconContainer,
  TileText,
} from 'src/supportPortal/views/home/styledComponents'
import useServerAuth from 'src/customHooks/useServerAuth'

export default function ClinicsNavPage() {
  const navigate = useNavigate()
  const { allRolesInBoolean } = useServerAuth()
  
  return (
    <>
      <SupportHeader heading={'Clinics & Hospitals'} showBackButton />
      <SupportHomePageContainer>
        {(allRolesInBoolean.isClinicSuccessManager || allRolesInBoolean.isClinicSuccessAdmin) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.clinics}
            onClick={() => navigate('/support-home/clinics-hospitals/clinics')}
          >
            <TileIconContainer>
              <Business />
            </TileIconContainer>
            <TileText>Clinics</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isClinicSuccessAdmin || allRolesInBoolean.isClinicSuccessManager) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.clinics}
            onClick={() => navigate('/support-home/clinics-hospitals/clinic-services/direct-entry')}
          >
            <TileIconContainer>
              <Business />
            </TileIconContainer>
            <TileText>Clinic Services (Direct Entry)</TileText>
          </SupportHomePageItem>
        )}
        {allRolesInBoolean.isClinicRosterManager && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.clinicRoster}
            onClick={() => navigate('/support-home/clinics-hospitals/clinic-roster')}
          >
            <TileIconContainer>
              <CalendarMonth />
            </TileIconContainer>
            <TileText>Clinic Roster</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isClinicSuccessAdmin || allRolesInBoolean.isClinicSuccessManager) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.clinicBrandInvoices}
            onClick={() => navigate('/support-home/clinics-hospitals/clinic-brand-invoices')}
          >
            <TileIconContainer>
              <Description />
            </TileIconContainer>
            <TileText>Clinic Brand Invoices</TileText>
          </SupportHomePageItem>
        )}
      </SupportHomePageContainer>
    </>
  )
}
